import './info.less'

import {Icon} from '@codeurs/front'
import React, {useState} from 'react'
import {WysiwygType} from 'types'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {Theme} from 'views/theme'

const styles = style('info', ['popup'])

export const Info: React.FC<{
	label: string
	popup: WysiwygType
}> = ({label, popup}) => {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<>
			<a
				className={styles()}
				onClick={e => {
					setIsOpen(true)
					e.preventDefault()
					return false
				}}
			>
				<Icon icon="information" />
			</a>
			<InfoPopup
				isOpen={isOpen}
				label={label}
				popup={popup}
				onClose={() => setIsOpen(false)}
			/>
		</>
	)
}

export const InfoPopup: React.FC<{
	label: string
	popup: WysiwygType
	isOpen: boolean
	onClose: () => void
}> = ({isOpen, label, popup, onClose}) => {
	return (
		<PopupModal open={isOpen} onClose={onClose}>
			<PopupModal.Block>
				<PopupModal.Content mod="big">
					{label && (
						<Theme.H1 as="h2" mod={['dots']}>
							{label}
						</Theme.H1>
					)}
					<PopupModal.Message mod="fullwidth">
						<Theme.Wysiwyg>{popup}</Theme.Wysiwyg>
					</PopupModal.Message>
				</PopupModal.Content>
				<PopupModal.Footer />
			</PopupModal.Block>
		</PopupModal>
	)
}
